// extracted by mini-css-extract-plugin
module.exports = {"description":"TermsPage_description_3R_mJ","block":"TermsPage_block_2SKd1"};